import InventariosView from "../../components/estoque/InventariosView";

export default function InventariosEstoque() {
  return <InventariosView />;
}
